import { Routes } from '@angular/router';
import { Home } from '../pages/home/home';
import { Login } from '../pages/login/login';
import { authGuard } from './authGuard';
import { NotFound } from '../pages/not-found/not-found';
import { FullWidthLayout } from '../layouts/full-width-layout/full-width-layout';
import { SidebarLayout } from '../layouts/sidebar-layout/sidebar-layout';
import { Materials } from '../pages/materials/materials';
import { Particles } from '../pages/particles/particles';
import { MetaParticles } from '../pages/meta-particles/meta-particles';
import { User } from '../pages/user/user';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    component: SidebarLayout,
    children: [
      { path: '', component: Home, pathMatch: 'full' },
      { path: 'materials', component: Materials },
      { path: 'particles', component: Particles },
      { path: 'meta-particles', component: MetaParticles },
      { path: 'user', component: User },
    ],
  },
  {
    path: '',
    component: FullWidthLayout,
    children: [
      { path: 'login', component: Login },
      { path: '404', component: NotFound },
    ],
  },
  { path: '**', redirectTo: '404' },
];
